import { render } from "./RightVehiclePanel.vue?vue&type=template&id=5e5d3604&scoped=true"
import script from "./RightVehiclePanel.vue?vue&type=script&lang=js"
export * from "./RightVehiclePanel.vue?vue&type=script&lang=js"

import "./RightVehiclePanel.vue?vue&type=style&index=0&id=5e5d3604&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5d3604"]])

export default __exports__